"use strict";

PF.Trait = class Trait
	{
	constructor(widget)
		{
		let target = Object.getPrototypeOf(this);
		if (widget.traits === undefined)
			{
			Object.defineProperty(widget, 'traits', {
				enumerable: false,
				configurable: true,
				value: {},
			});
			// Object.defineProperty(widget, 'traitMethods', {
			// 	enumerable: false,
			// 	value: [],
			// });
			// widget.traits = {};
			}
		while (target.constructor.name !== 'Trait')
			{
			let methods = Object.getOwnPropertyNames(target);

			widget.traits[target.constructor.name] = {class: this.constructor, methods: [] };
			for (let i = 0; i < methods.length; i++)
				{
				let methodName = methods[i];
				if (typeof this[methodName] === 'function')
					{
					if (methodName !== 'constructor' && methodName !== 'init' && methodName !== 'destroy' && widget[methodName] === undefined)
						{
						widget.traits[target.constructor.name].methods.push(methodName);
						Object.defineProperty(widget, methodName, {
							configurable: true,
							enumerable: false,
							value: this[methodName].bind(widget),
						});
						// this[methodName] = this[methodName].bind(widget);
						// widget[methodName] = this[methodName].bind(widget);
						}
					}
				}

			target = Object.getPrototypeOf(target);
			}
		// widget[field] = this;


		this.initTrait.apply(widget);
		}

	initTrait()
		{

		}

	init()
		{

		}
	};
